<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { type ReportTabsType, ReportTabsTypes } from '@/entities/Report'
import { ObjectAliases } from '@/entities/Object'

const route = useRoute()
const router = useRouter()

const type = ref<string>((route.params.report_type as string) || 'readings')

/** Отслеживаем изменение типа вкладки делаем переадресацию */
watch(type, () => {
  router.push({
    name: route.name,
    params: {
      ...route.params,
      report_type: type.value,
    },
  })
})

/** Вычисляем вкладки отчетов касающиеся шкафов */
const tabs = computed(() => {
  const list: ReportTabsType[] = []

  for (const item in ReportTabsTypes) {
    const type = ReportTabsTypes[item]

    if (type.objects.includes(ObjectAliases.CABINETS)) list.push(type)
  }

  return list
})
</script>

<template>
  <VTabs v-model="type">
    <VTab v-for="tab in tabs" :value="tab.id">{{ $t(tab.label) }}</VTab>
  </VTabs>
</template>
